import { Skeleton, useStyletron } from '@olxeu-jobs/ui';
import { LoaderWrapper } from './styled-components';
import { EmployerCardLayout } from './employer-card-layout';

export const EmployerCardLoader = () => {
  const [css] = useStyletron();

  return (
    <LoaderWrapper>
      <EmployerCardLayout
        header=""
        content=""
        className={css({
          visibility: 'hidden',
        })}
      />
      <Skeleton
        variant="image"
        width="100%"
        height="100%"
        $style={{ position: 'absolute', left: 0, top: 0 }}
      />
    </LoaderWrapper>
  );
};
